/* global __SERVER__ */

import React, { PureComponent } from 'react';
import { asyncConnect } from 'redux-connect';
import { connect } from 'react-redux';

import { fetchEvent, fetchEvents } from '../../state/actions';
import { setRecentEventVisits } from '../../utils/localStorage';
import {
  getEventSelectedError,
  getEvent,
  getEventSelectedFetching,
} from '../../state/reducers';
import {trackEventShared, trackEventVisit, trackTicketsVisit} from '../../utils/tracking';
import EventDetailPage from '../../components/EventDetailPage';
import { getObjFromHashParamString } from '../../utils/urls';


const getSearchQuery = event => event && ({
  resultsPerPage: 6,
  excludeId: event.id,
  sort: 'date',
  organiser: event.organiser && event.organiser.id,
});

const getSimilarQuery = event => event && ({
  resultsPerPage: 6,
  excludeId: event.id,
  sort: 'nearby',
  sport: event.races && event.races.races[0].information.sport,
  sportDistance: event.races &&
    event.races.races[0].information &&
    event.races.races[0].information.distance,
  locationLat: event.location.lat,
  locationLong: event.location.long,
});

/**
 * Event detail page container.
 * Wraps the event detail page presentational component with Redux state.
 * Adds props to component representing fetch state and event object result.
 */
class EventDetailPageContainer extends PureComponent {
  componentWillMount() {
    // If the error has a status code, overwrite the route
    const { error, route } = this.props;
    if (error && error.status) {
      route.status = error.status;
    }
  }

  componentDidMount() {
    const { event, router, location } = this.props;
    // Push the event slug to the URL if it's absent
    if (event && !router.params.eventSlug) {
      router.replace(`${event.permalink}${location.search}${location.hash}`);
    }
    this.trackVisit();
  }

  componentDidUpdate(prevProps) {
    const { event: previousEvent } = prevProps;
    const { event: newEvent } = this.props;
    if ((previousEvent && previousEvent.id) !== (newEvent && newEvent.id)) {
      this.trackVisit();
    }
  }

  trackVisit = () => {
    // Event data may be detailed or abridged, depending on user journey
    const { event, location } = this.props;
    if (event) {
      trackEventVisit(event, getObjFromHashParamString(location.hash).source);
      // Store event visit in local storage
      setRecentEventVisits(event.id);
    }
  }

  trackEventShare = (sharedVia) => {
    const { event } = this.props;
    if (event) {
      trackEventShared(event, sharedVia);
    }
  }

  render() {
    return (
      <EventDetailPage
        {...this.props}
        onShare={this.trackEventShare}
        searchQuery={getSearchQuery(this.props.event)}
        similarQuery={getSimilarQuery(this.props.event)}
      />
    );
  }
}

EventDetailPageContainer.propTypes = EventDetailPage.propTypes;

// Selectors are used so state shape is encapsulated within reducers
export const mapStateToProps = (state, { params: { eventId } }) => ({
  error: getEventSelectedError(state),
  event: getEvent(state, eventId),
  fetching: getEventSelectedFetching(state),
});

// Wrap in [react-redux connect](https://github.com/reactjs/react-redux/blob/master/docs/api.md#connect)
const EventDetailPageWithConnect = connect(mapStateToProps)(EventDetailPageContainer);

// Configure promises that must be fulfilled before the component is rendered, e.g. fetch event data
export const asyncPromises = [{
  promise: ({ params, store: { dispatch } }) => {
    const action = new Promise((resolve, reject) => {
      dispatch(fetchEvent(params.eventId))
        .then((response) => {
          if (!(response && response.value)) {
            reject('No event found');
            return;
          }
          Promise.all([
            dispatch(fetchEvents(getSearchQuery(response.value))),
            dispatch(fetchEvents(getSimilarQuery(response.value))),
          ])
            .then((values) => { resolve(values); })
            .catch(e => reject(e));
        }).catch(e => reject(e));
    });

    return __SERVER__ ? action : Promise.resolve();
  },
}];

// Wrap in [redux-connect](https://github.com/makeomatic/redux-connect)
const EventDetailPageContainerWithAsync = asyncConnect(asyncPromises)(EventDetailPageWithConnect);

export default EventDetailPageContainerWithAsync;



// WEBPACK FOOTER //
// ./app/src/containers/EventDetailPage/index.jsx